import { cn } from "../lib/utils";
import { CheckCircle2, Wrench, AlertOctagon, PowerOff } from "lucide-react";

export const STATUS_META = {
  siap_jalan: { label: "Siap Jalan", icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  maintenance: { label: "Maintenance", icon: Wrench, cls: "bg-amber-100 text-amber-800 border-amber-300" },
  rusak: { label: "Rusak", icon: AlertOctagon, cls: "bg-red-100 text-red-800 border-red-300" },
  non_aktif: { label: "Non-Aktif", icon: PowerOff, cls: "bg-slate-200 text-slate-700 border-slate-400" },
};

export function StatusBadge({ status, className, testId }) {
  const meta = STATUS_META[status] || STATUS_META.siap_jalan;
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border text-[10px] font-bold uppercase tracking-wider",
        meta.cls,
        className,
      )}
      data-testid={testId}
    >
      <Icon className="w-3 h-3" />
      {meta.label}
    </span>
  );
}
